import React, { useState } from 'react';
import PolicyPopup from './PolicyPopup';
const Footer = () => {
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  const [activePolicyType, setActivePolicyType] = useState<'privacy' | 'terms' | 'warranty'>('privacy');
  const openPolicy = (type: 'privacy' | 'terms' | 'warranty') => {
    setActivePolicyType(type);
    setIsPolicyOpen(true);
  };
  return <footer className="bg-gray-800 text-white py-12" data-id="element-166">
      <div className="container mx-auto px-4" data-id="element-167">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-168">
          <div data-id="element-169">
            <h3 className="text-xl font-bold mb-4" data-id="element-170">Corona de alivio</h3>
            <p className="text-gray-400" data-id="element-171">
              Soluciones innovadoras para el alivio del dolor de migraña.
            </p>
          </div>
          <div data-id="element-172">
            <h4 className="text-lg font-semibold mb-4" data-id="element-173">
              Términos y Condiciones
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-174">
              <li data-id="element-175">
                <button onClick={() => openPolicy('privacy')} className="hover:text-white transition-colors text-left" data-id="element-176">
                  Política de Privacidad
                </button>
              </li>
              <li data-id="element-177">
                <button onClick={() => openPolicy('terms')} className="hover:text-white transition-colors text-left" data-id="element-178">
                  Términos de Uso
                </button>
              </li>
              <li data-id="element-179">
                <button onClick={() => openPolicy('warranty')} className="hover:text-white transition-colors text-left" data-id="element-180">
                  Garantía de Producto
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-181">
            <h4 className="text-lg font-semibold mb-4" data-id="element-182">Aviso Médico</h4>
            <p className="text-gray-400 text-sm" data-id="element-183">
              Este producto no está destinado a diagnosticar, tratar, curar o
              prevenir ninguna enfermedad. Consulte a su médico antes de usar si
              tiene condiciones médicas preexistentes.
            </p>
          </div>
          <div data-id="element-184">
            <h4 className="text-lg font-semibold mb-4" data-id="element-185">Contacto</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-186">
              <li className="flex items-center" data-id="element-187">
                <span className="mr-2" data-id="element-188">📞</span>
                <span data-id="element-189">+50376668786</span>
              </li>
              <li className="flex items-center" data-id="element-190">
                <span className="mr-2" data-id="element-191">✉️</span>
                <span data-id="element-192">contacto@shopysv.com</span>
              </li>
              <li className="mt-4 pt-4 border-t border-gray-700" data-id="element-193">
                <h5 className="font-medium mb-2" data-id="element-194">Políticas de Envío</h5>
                <p className="text-sm" data-id="element-195">
                  Envío gratuito a todo El Salvador. Entrega en 24-48 horas
                  hábiles.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400" data-id="element-196">
          <p data-id="element-197">
            &copy; {new Date().getFullYear()} Corona de alivio. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
      <PolicyPopup isOpen={isPolicyOpen} onClose={() => setIsPolicyOpen(false)} initialPolicy={activePolicyType} data-id="element-198" />
    </footer>;
};
export default Footer;